import loadIntersectionObserver from '@utils/browser/intersectionObserver/loadPolyfill';

export function loadRequiredPolyfills() {
  return loadIntersectionObserver();
}
